module.exports = __webpack_public_path__ + "img/waloneName.f5e2eb74.svg";